import { Media } from "./media";

export function formatBytes(bytes: number, decimals = 2): string {
	if (bytes === 0) return "0 Bytes";

	const k = 1024;
	const dm = decimals < 0 ? 0 : decimals;
	const sizes = ["Bytes", "KB", "MB", "GB"];

	const i = Math.floor(Math.log(bytes) / Math.log(k));

	return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}

export function isVideo(asset: Media): boolean {
	return asset.mimeType.startsWith("video/");
}

export function isImage(asset: Media): boolean {
	return asset.mimeType.startsWith("image/");
}
